import ApiWrapper from './useApi.hook';
import { createPersonThunk, updatePersonThunk } from '../redux/Candidate/Candidate.thunk';
import { Person } from '../redux/Candidate/Candidate.type';
import { PersonCreateFetch, PersonUpdateFetch } from '../redux/Candidate/Experience/PersonExperience.type';
import { useAppSelector } from './useAppSelector.hook';
import { getInternshipSelected } from '../redux/Internship/Internship.slice';
import {
  addInternshipCandidateThunk,
  getInternshipInfoThunk,
  getInternshipPeopleListThunk,
} from '../redux/Internship/Internship.thunk';
import { useAppDispatch } from './useAppDispatcher.hook';
import { resetCandidateSelectedAction } from '../redux/Candidate/Candidate.slice';

export const useInternship = () => {
  const { item: selectedInternship } = useAppSelector(getInternshipSelected);
  const dispatch = useAppDispatch();

  const updatePersonResult = (payload: PersonUpdateFetch) => {
    ApiWrapper(
      updatePersonThunk(payload),
    ).then((res: Person | boolean) => {
      appendToInternship(res as Person);
    });
  };

  const savePersonResult = (payload: PersonCreateFetch) => {
    ApiWrapper(
      createPersonThunk({
        ...payload,
        hasSoftSearch: false,
      }),
    ).then((res: Person | boolean) => {
      appendToInternship(res as Person);
    });
  };

  const appendToInternship = (payload: any) => {
    if (selectedInternship) {
      ApiWrapper(
        addInternshipCandidateThunk({
          id: selectedInternship.id,
          payload,
        }),
      ).then(() => {
        dispatch(getInternshipPeopleListThunk({ id: selectedInternship.id }));
        dispatch(getInternshipInfoThunk(selectedInternship.id));
        dispatch(resetCandidateSelectedAction(undefined));
      });
    }
  };
  return {
    updatePersonResult,
    savePersonResult,
  };
};